import * as AdminEnhancedDomain from '../__generated/admin-enhanced-model.js';
import { createMapPublishedRevisionDataHandler } from '../__generated/admin-implementation.js';
import * as EnhancedDomain from '../__generated/enhanced-model.js';
export const mapPublishedRevisionDataHandler = createMapPublishedRevisionDataHandler(({ adminEntity })=>{
    const cabinetSolidColors = adminEntity.$cabinetMaterials.filter(AdminEnhancedDomain.$CabinetSolidColorMaterial.is).map((color)=>({
            name: color.name,
            color: color.color.toLowerCase(),
            materialName: EnhancedDomain.constants.Cabinet.$defaultMaterialName,
            swatchUrl: null
        }));
    const cabinetWoodTextureColors = adminEntity.$cabinetMaterials.filter(AdminEnhancedDomain.$CabinetWoodTextureMaterial.is).map((material)=>({
            name: material.$name,
            color: null,
            materialName: material.materialName,
            swatchUrl: material.$swatchUrl
        }));
    const cabinetMaterials = [
        ...cabinetSolidColors,
        ...cabinetWoodTextureColors
    ];
    const countertopSolidColors = adminEntity.$countertopMaterials.filter(AdminEnhancedDomain.$CountertopSolidColorMaterial.is).map((color)=>({
            name: color.name,
            color: color.color.toLowerCase(),
            materialName: EnhancedDomain.constants.Countertop.$defaultMaterialName,
            swatchUrl: null
        }));
    const countertopWoodTextureColors = adminEntity.$countertopMaterials.filter(AdminEnhancedDomain.$CountertopWoodTextureMaterial.is).map((material)=>({
            name: material.$name,
            color: null,
            materialName: material.materialName,
            swatchUrl: material.$swatchUrl
        }));
    const countertopMaterials = [
        ...countertopSolidColors,
        ...countertopWoodTextureColors
    ];
    const segmentPrices = adminEntity.$segmentPrices.map((sp)=>({
            productCode: sp.product_code,
            materialType: sp.material_type,
            width: sp.width,
            price: sp.price
        }));
    return {
        cabinetMaterials,
        countertopMaterials,
        segmentPrices
    };
});

//# sourceMappingURL=map-published-revision-data.js.map